<script setup lang="ts">
import type { DropdownMenuItem } from '../types/common';
import DropDownMenuButton from './DropDownMenuButton.vue';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps({
    width: {
        type: String,
        default: '100%'
    },
    height: {
        type: String,
        default: '280px'
    },
    title: {
        type: [String, Number],
        default: ''
    },
    subTitle: {
        type: [String, Number],
        default: ''
    },
    icon: {
        type: String,
        default: ''
    },
    actions: {
        type: Array as PropType<DropdownMenuItem[] | null>,
        default: null
    }
});
const slots = useSlots();

const hasSlot = (name: string): boolean => {
    return !!slots[name];
};

const emit = defineEmits(['card-click']);

</script>

<template>
    <VLCard
        class="vl-card overflow-hidden cursor-pointer"
        :style="{ width: width, height: height }"
        @click="emit('card-click')"
    >
        <template #header>
            <div class="flex justify-between items-center p-3">
                <div v-if="hasSlot('title-start')">
                    <slot name="title-start" />
                </div>
                <p
                    class="text-2xl overflow-hidden overflow-ellipsis whitespace-nowrap max-w-4/5 font-light"
                    @click="emit('card-click')"
                >
                    {{ title }}
                </p>
                <div
                    class="flex items-center gap-2"
                >
                    <p
                        class="text-2xl font-light"
                        @click="emit('card-click')"
                    >
                        {{ subTitle }}
                    </p>

                    <div v-if="hasSlot('title-end')">
                        <slot name="title-end" />
                    </div>

                    <drop-down-menu-button
                        v-if="actions && actions.length > 0"
                        :menu-list="actions!"
                    />
                </div>
            </div>
        </template>

        <template #content>
            <div
                class="h-full"
            >
                <slot
                    name="default"
                />
            </div>
        </template>
    </VLCard>
</template>

<style scoped>
:deep(.p-card-body) {
    padding-top: 0;
}

.vl-card {
    border: solid 1px var(--main-border-color);
}

.vl-card {
    transition: box-shadow 0.4s ease-in-out;
}

.vl-card:hover {
    box-shadow: 2px 4px 8px var(--main-border-color-dark);
}

</style>
